<template>
  <v-container>
         <h1>Handbuch</h1>

        <div style="height: 66vh">
          <Pdf v-if="runDocuments && runDocuments[0] && runDocumentsLoaded" :pdf-url="getDownloadUrl()"/>
          <div v-else>Kein Handbuch verfügbar</div>
        </div>

  </v-container>
</template>

<script>
import { mapState } from 'vuex';
import LoadingState from '@/api/LoadingState';
import Pdf from './Pdf.vue';

export default {
  // eslint-disable vue/multi-word-component-names
  name: 'Manual',
  components: {
    Pdf,
  },
  data: () => ({
    editor: null,
    penInk: '',
    observationData: null,
    currentObservation: {},
  }),
  computed: {
    ...mapState({
      runDocuments: (state) => state.run.runDocuments,
      runDocumentsLoaded: (state) => state.run.loadingState.runDocuments === LoadingState.LOADED,
    })
  },
  methods: {
    getDownloadUrl() {
      return `document/${this.runDocuments[0]}`;
    },
  },
  mounted() {},
  beforeDestroy() {},
};
</script>
